<template>
    <article>
        <div class="header" :style="'background-image: url('+thematique.img_bg+')'">
            <h2 class="titre">{{thematique.name}}</h2>
            <p>{{thematique.parent.name}}</p>
            <div class="legende" v-html="thematique.img_legend"></div>
        </div>
        <aside>
            <div class="description">
                <h3 class="sous-titre">{{thematique.sous_titre}}</h3>
                <div v-html="thematique.description"></div>
            </div>
            <div class="list">
                <p class="count" v-html="formatThematiqueCount(thematique.count)"></p>

                <transition-group name="fade" tag="ul"
                                  v-bind:css="false"
                                  v-on:before-enter="beforeEnter"
                                  v-on:enter="enter"
                >
                    <li v-for="(cruise, index) in thematique.cruises" v-if="index < cruiseShowLimit" :key="index"
                        :data-index="index">
                        <a :href="cruise.permalink" class="lien-inline"
                           v-html="formatName(cruise.post_title)"></a>
                    </li>
                </transition-group>

                <transition>
                    <p class="more"
                       @click="showMore = !showMore"
                       v-if="showButtonMore">Voir plus de croisières</p>
                </transition>
            </div>
        </aside>
    </article>
</template>

<script>
    import $ from 'jquery'

    export default {
        props: {
            thematique: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                showMore: false,
                defaultshowLimit: 3,
                firstAppear: true
            };
        },
        computed: {
            cruiseShowLimit() {
                if (this.showMore) {
                    return 99999
                }
                else {
                    return this.defaultshowLimit
                }
            },
            showButtonMore() {
                if (!this.showMore && this.thematique.cruises.length > this.defaultshowLimit) {
                    return true
                } else {
                    return false
                }

            }
        },
        methods: {
            formatName(value) {
                return value.replace("<br>", "")
            },
            formatThematiqueCount(count){
                return count > 1 ? `${count} voyages disponibles` : `${count} voyage disponible`
            },
            beforeEnter: function (el) {
                $(el).removeClass('show');
                $(el).addClass('hidden');
            },
            enter: function (el, done) {
                var delay = el.dataset.index * 150
                setTimeout(() => {
                    $(el).addClass('show');
                }, delay);

            },

        },
        mounted() {
            setTimeout(() => {
                this.firstAppear = false
            }, 1000)
        }

    }
</script>



// WEBPACK FOOTER //
// assets/js/components/taxonomy-thematique/ThematiqueCard.vue